import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";
import { isOperative, operativeCanVisit } from "@/lib/api";

export function ProtectedRoute({ children, requireSuperAdmin = false }) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex items-center gap-3 text-muted-foreground">
          <Loader2 className="h-5 w-5 animate-spin" />
          <span className="text-sm">Cargando TallerOS…</span>
        </div>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Cambio forzado de contraseña: bloquea toda navegación hasta completarlo.
  if (
    session.user?.must_change_password &&
    location.pathname !== "/cambiar-contrasena"
  ) {
    return <Navigate to="/cambiar-contrasena" replace />;
  }

  if (isOperative(session.user) && !operativeCanVisit(location.pathname)) {
    return <Navigate to="/mis-trabajos" replace />;
  }

  if (requireSuperAdmin && !session.user?.is_super_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
